import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { modifier } from 'ember-modifier';

interface RenderMailTemplateSignature {
  Args: {
    Positional: [htmlContent: string];
  };
  Element: HTMLIFrameElement;
}

const renderMailTemplate = modifier<RenderMailTemplateSignature>(
  (element, [htmlContent]): void => {
    const { contentWindow } = element;

    if (!contentWindow) {
      return;
    }

    contentWindow.document.open();
    contentWindow.document.write(htmlContent);
    contentWindow.document.close();
  },
);

interface ParityParityManagerMailTemplateRendererSignature {
  Args: {
    htmlContent: string;
    isLoading?: boolean;
  };
}

const ParityParityManagerMailTemplateRenderer = <template>
  {{! template-lint-disable require-iframe-title }}
  {{#if @isLoading}}
    <span class="centered-message">
      {{t "general.loading"}}
    </span>
  {{else if @htmlContent}}
    <iframe
      id="mail-renderer-iframe"
      {{renderMailTemplate @htmlContent}}
    ></iframe>
  {{else}}
    <span class="centered-message">
      {{t "parity_manager.violation_mail_modal.template_error"}}
    </span>
  {{/if}}
</template> satisfies TOC<ParityParityManagerMailTemplateRendererSignature>;

export default ParityParityManagerMailTemplateRenderer;
